import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  token: sessionStorage.getItem('access_token') || null,
  // token: sessionStorage.getItem('access_token_yx') || null,
  userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {},
  flowInfo: JSON.parse(sessionStorage.getItem('flowInfo')) || {},
  currentProcedureInfo: JSON.parse(sessionStorage.getItem('currentProcedureInfo')) || {},
  loanFile: {
    id: '',
    files: [],
    filesData: []
  },
  loanInfo: [
    {
      name: '缓交类型',
      label: '缓交类型',
      value2: [],
      value: ''
    },
    {
      name: '申请金额',
      label: '申请金额',
      value: ''
    },
    {
      name: '申请原因',
      label: '申请原因',
      value: ''
    },
    {
      name: '审批金额',
      label: '审批金额',
      value: ''
    },
    {
      isEdit: 0,
      status: ''
    }
  ],
  addressFile: {
    files: [],
    filesData: []
  },
  addressInfo: JSON.parse(sessionStorage.getItem('addressInfo')) || [
    {
      name: '原户口省份简称',
      label: '原户口省份简称',
      value2: [],
      value: ''
    },
    {
      name: '编号',
      label: '编号',
      value: ''
    },
    {
      name: '迁移证号',
      label: '迁移证号',
      value: ''
    }
  ],
  carInfo: JSON.parse(sessionStorage.getItem('carInfo')) || [],
  clothesInfo: JSON.parse(sessionStorage.getItem('clothesInfo')) || [],
  stepListValue: 0,
  itemFormData: {
    isNext: false,
    data: {}
  },
  initFlowInfo: JSON.parse(sessionStorage.getItem('initFlowInfo')) || {},
  accountNotIsExist: false,
  studentInfo: {}
}

const getters = {
}

const mutations = {
  Login (state, token) {
    sessionStorage.setItem('access_token', token)
    // sessionStorage.setItem('access_token_yx', token)
    state.token = token
  },
  Logout (state) {
    sessionStorage.removeItem('access_token')
    // sessionStorage.removeItem('access_token_yx')
    sessionStorage.clear()
    state.token = null
  },
  userInfo (state, userInfo) {
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    state.userInfo = userInfo
  },
  flowInfo (state, flowInfo) {
    sessionStorage.setItem('flowInfo', JSON.stringify(flowInfo))
    state.flowInfo = flowInfo
  },
  currentProcedureInfo (state, currentProcedureInfo) {
    sessionStorage.setItem('currentProcedureInfo', JSON.stringify(currentProcedureInfo))
    state.currentProcedureInfo = currentProcedureInfo
  },
  loanFile (state, loanFile) {
    state.loanFile = loanFile
  },
  loanInfo (state, loanInfo) {
    sessionStorage.setItem('loanInfo', JSON.stringify(loanInfo))
    state.loanInfo = loanInfo
  },
  addressFile (state, addressFile) {
    // localStorage.setItem('addressFile', JSON.stringify(addressFile))
    state.addressFile = addressFile
  },
  addressInfo (state, addressInfo) {
    sessionStorage.setItem('addressInfo', JSON.stringify(addressInfo))
    state.addressInfo = addressInfo
  },
  carInfo (state, carInfo) {
    sessionStorage.setItem('carInfo', JSON.stringify(carInfo))
    state.carInfo = carInfo
  },
  clothesInfo (state, clothesInfo) {
    sessionStorage.setItem('clothesInfo', JSON.stringify(clothesInfo))
    state.clothesInfo = clothesInfo
  },
  itemFormData (state, itemFormData) {
    state.itemFormData = itemFormData
  },
  stepListValue (state, stepListValue) {
    state.stepListValue = stepListValue
  },
  initFlowInfo (state, initFlowInfo) {
    state.initFlowInfo = initFlowInfo
  },
  accountNotIsExist (state, accountNotIsExist) {
    state.accountNotIsExist = accountNotIsExist
  },
  studentInfo (state, studentInfo) {
    state.studentInfo = studentInfo
  }
}
const actions = {
  LoginAction (context, token) {
    context.commit('Login', token)
  },
  LogoutAction (context) {
    context.commit('Logout')
  },
  userInfoAction (context, userInfo) {
    context.commit('userInfo', userInfo)
  },
  flowInfoAction (context, flowInfo) {
    context.commit('flowInfo', flowInfo)
  },
  currentProcedureInfoAction (context, currentProcedureInfo) {
    context.commit('currentProcedureInfo', currentProcedureInfo)
  },
  loanFileAction (context, loanFile) {
    context.commit('loanFile', loanFile)
  },
  loanInfoAction (context, loanInfo) {
    context.commit('loanInfo', loanInfo)
  },
  addressFileAction (context, addressFile) {
    context.commit('addressFile', addressFile)
  },
  addressInfoAction (context, addressInfo) {
    context.commit('addressInfo', addressInfo)
  },
  carInfoAction (context, carInfo) {
    context.commit('carInfo', carInfo)
  },
  clothesInfoAction (context, clothesInfo) {
    context.commit('clothesInfo', clothesInfo)
  },
  itemFormDataAction (context, itemFormData) {
    context.commit('itemFormData', itemFormData)
  },
  stepListValueAction (context, stepListValue) {
    context.commit('stepListValue', stepListValue)
  },
  initFlowInfoAction (context, initFlowInfoAction) {
    context.commit('initFlowInfo', initFlowInfoAction)
  },
  accountNotIsExistAction (context, accountNotIsExist) {
    context.commit('accountNotIsExist', accountNotIsExist)
  },
  studentInfoAction (context, studentInfo) {
    context.commit('studentInfo', studentInfo)
  }
}

// 防止页面刷新vuex中的数据丢失
export default new Vuex.Store({
  namespaced: true,
  state,
  getters,
  mutations,
  actions
})

/*
var obj = { name:'Jim' };
var str = JSON.stringify(obj);

//存入
sessionStorage.obj = str;
//读取
str = sessionStorage.obj;
//重新转换为对象
obj = JSON.parse(str);
*/



// WEBPACK FOOTER //
// ./src/store/index.js